import { useState } from 'react';
import { OWNER_FILTER_ITEMS as Owner } from '../constants/constants';
import { SelectChangeEvent } from '@mui/material/Select';
import EvesSelect from '@/common/components/atoms/select/select';
import { useTranslation } from 'react-i18next';

export interface OwnerIssuerInfo {
	issuer?: boolean;
	issuerName: string;
	defaultIssuer: boolean;
}

interface OwnerFilterProps {
	defaultIssuer?: boolean;
	onChange: (issuerInfo: OwnerIssuerInfo) => void;
}

export default function OwnerFilter(props: OwnerFilterProps) {
	const { t: translate } = useTranslation();
	const currentOrgLabel = translate(Owner.CurrentOrganization);
	const externalOrgLabel = translate(Owner.ExternalOrganization);
	const [ownerName, setOwnerName] = useState(currentOrgLabel);

	const selectedValue = props.defaultIssuer ? currentOrgLabel : ownerName;

	const getIssuerInfo = (selectedOwner: string): OwnerIssuerInfo => {
		if (selectedOwner === currentOrgLabel) {
			return {
				issuer: true,
				issuerName: Owner.CurrentOrgAPI,
				defaultIssuer: false,
			};
		}

		return {
			issuer: false,
			issuerName: Owner.ExternalOrgAPI,
			defaultIssuer: false,
		};
	};

	const handleChange = (event: SelectChangeEvent<string>) => {
		const value = event.target.value;
		setOwnerName(value);
		props.onChange(getIssuerInfo(value));
	};

	return (
		<EvesSelect
			isFilter={true}
			label={translate('issuer.title')}
			value={selectedValue}
			onChange={handleChange}
			shrink={true}
			id="OwnerMultiselect"
			labelId="OwnerMultiSelectInputLabel"
			SelectDisplayProps={{ 'data-cy': 'filter-main' } as any}
			options={[
				{ value: currentOrgLabel, label: currentOrgLabel },
				{ value: externalOrgLabel, label: externalOrgLabel },
			]}
		/>
	);
}
